module.exports = __webpack_public_path__ + "files/02a4283c44eb5c01cca7d635fa5cc0c0.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/places-3.png
// module id = 1382
// module chunks = 59